/**
 * Chi si registra sul sito (docs/13-api.md §2, "Profilo"): al primo accesso si chiedono il nome
 * e chi è. La redazione lo vede nelle segnalazioni (una Pro Loco o un Comune che segnala la
 * propria festa è una fonte diversa da un privato). Senza zod: si usa anche nel browser
 * (`@sse/schema/profile`).
 */
export const PROFILE_KINDS = [
    'persona',
    'associazione',
    'comune',
    'parrocchia',
    'azienda',
    'organizzatore',
    'media',
    'altro',
];
/** Etichette per il pannello e il bot (il sito ha le sue, tradotte). */
export const PROFILE_KIND_LABELS = {
    persona: 'Privato',
    associazione: 'Associazione, Pro Loco o comitato',
    comune: 'Comune o ente pubblico',
    parrocchia: 'Parrocchia o confraternita',
    azienda: 'Azienda, locale o attività',
    organizzatore: 'Organizzatore di eventi o agenzia',
    media: 'Giornale, blog o pagina social',
    altro: 'Altro',
};
//# sourceMappingURL=profile.js.map